// source: messages/schemas/progress.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

var messages_schemas_source_pb = require("../../messages/schemas/source_pb.js");
goog.object.extend(proto, messages_schemas_source_pb);
goog.exportSymbol("proto.Progress", null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Progress = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Progress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Progress.displayName = "proto.Progress";
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.Progress.prototype.toObject = function (opt_includeInstance) {
    return proto.Progress.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.Progress} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.Progress.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        source:
          (f = msg.getSource()) &&
          messages_schemas_source_pb.Source.toObject(includeInstance, f),
        progress: jspb.Message.getFieldWithDefault(msg, 2, 0),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Progress}
 */
proto.Progress.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Progress();
  return proto.Progress.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Progress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Progress}
 */
proto.Progress.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new messages_schemas_source_pb.Source();
        reader.readMessage(
          value,
          messages_schemas_source_pb.Source.deserializeBinaryFromReader,
        );
        msg.setSource(value);
        break;
      case 2:
        var value = /** @type {number} */ reader.readInt32();
        msg.setProgress(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Progress.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.Progress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Progress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Progress.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messages_schemas_source_pb.Source.serializeBinaryToWriter,
    );
  }
  f = message.getProgress();
  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};

/**
 * optional Source source = 1;
 * @return {?proto.Source}
 */
proto.Progress.prototype.getSource = function () {
  return /** @type{?proto.Source} */ jspb.Message.getWrapperField(
    this,
    messages_schemas_source_pb.Source,
    1,
  );
};

/** @param {?proto.Source|undefined} value */
proto.Progress.prototype.setSource = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 */
proto.Progress.prototype.clearSource = function () {
  this.setSource(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Progress.prototype.hasSource = function () {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional int32 progress = 2;
 * @return {number}
 */
proto.Progress.prototype.getProgress = function () {
  return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};

/** @param {number} value */
proto.Progress.prototype.setProgress = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

goog.object.extend(exports, proto);
